import React from 'react';
import Skeleton from '@mui/lab/Skeleton';

const TextFieldSkeleton = () => {
  return <Skeleton variant="rectangular" animation="wave" height="100%" width="100%" />;
};
export default TextFieldSkeleton;
